import { runningInRNWebView, useReactNativeProps } from '@eika-infrastruktur/mobilbank-lib';

import { useConfig } from '../defaultConfig';
import { usePushDevice } from '../fetchHooks/usePushDevice';

export const useUnactivatedPush = (enabled: boolean) => {
    const {
        pushSettingsLink,
        featureToggles: { enablePushNotifications },
    } = useConfig();

    const { supports } = useReactNativeProps();

    const couldHavePush =
        enabled &&
        supports?.pushNotificationsV2 === true &&
        supports?.cookies === true &&
        runningInRNWebView &&
        enablePushNotifications &&
        !!pushSettingsLink;

    const { data: pushDevice, isSuccess } = usePushDevice(couldHavePush);
    return pushDevice?.enabled === false && couldHavePush && isSuccess;
};
